import { createContext, useContext } from "react";

import { Decimal18 } from "@astrid-dao/lib-base";
import { EthersTransactionOverrides } from "@astrid-dao/lib-ethers";

// TODO: Create types for each view
export type ConvertWastrView = "NO_APPROVAL" | "DEPOSITING" | "WITHDRAWING";

// TODO: Create types for each action
export type ConvertWastrViewAction = { type: "startDepositing" | "startWithdrawing" };

export type ConvertWastrViewContextType = {
  view: ConvertWastrView;

  // Indicates that a token convertion TX is pending.
  // The panel should be covered with a spinner overlay when this is true.
  changePending: boolean;

  // Dispatch an action that changes the Convert Wastr panel's view.
  dispatch: (action: ConvertWastrViewAction) => void;

  data:
    | {
        wastrBalance: Decimal18;
        wastrAllowance: Decimal18;
      }
    | undefined;

  approveWastr: (amount: Decimal18) => any;
  depositAstr: (amount: Decimal18, overrides?: EthersTransactionOverrides) => any;
  withdrawWastr: (amount: Decimal18, overrides?: EthersTransactionOverrides) => any;
};

export const ConvertWastrViewContext = createContext<ConvertWastrViewContextType | null>(null);

export const useConvertWastrView = (): ConvertWastrViewContextType => {
  const context = useContext(ConvertWastrViewContext);

  if (context === null) {
    throw new Error("You must add a <VaultViewProvider> into the React tree");
  }

  return context;
};
